/*
 *  -----------------------------------------------------------------------
 *    <copyright file="cm/risk-overview-legend-icons.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ILegendIconItem, LegendIconsProps } from '@components/central-monitoring/legend-icons/legend-icons.interface';

import { useTranslation } from '@hooks/index';

import './legend-icons.scss';

const LegendIcons = ({ showIncludeScoring = true, withLabel }: LegendIconsProps) => {
    const { t } = useTranslation();

    const legendIconItems: ILegendIconItem[] = [
        { icon: 'arrow-circle-down', text: t('cm:fallingScore') },
        { icon: 'arrow-circle-up', text: t('cm:risingScore') },
        { icon: 'minus-circle', text: t('cm:stableScore') },
        ...(showIncludeScoring ? [{ icon: 'check-circle', text: t('cm:includedInScoring') } as ILegendIconItem] : []),
        { label: 'U', text: t('cm:aboveBenchmark'), className: 'legend-icon' },
        { label: 'L', text: t('cm:belowBenchmark'), className: 'legend-icon' },
    ];

    return (
        <div className="icons-wrapper-legend">
            {withLabel && <p className="legend-label">{t('cm:legendLabel')}:</p>}
            {legendIconItems.map((item) => (
                <span key={item.text} className="legend-item">
                    {!!item.icon && <FontAwesomeIcon icon={['fal', item.icon]} className="legend-icon" />}
                    {!!item.label && <p className={item.className}>{item.label}</p>}
                    <p>{item.text}</p>
                </span>
            ))}
            <span className="legend-item">
                <p className="legend-icon">{t('cm:selectedDatasetAbbreviation')}</p>
                <p>{t('cm:legendSelectedDataset')}</p>
            </span>
            <span className="legend-item">
                <p className="legend-icon">{t('cm:comparisonDatasetAbbreviation')}</p>
                <p>{t('cm:legendComparisonDataset')}</p>
            </span>
            <span className="legend-item">
                <p className="legend-icon">{t('cm:changeAbbreviation')}</p>
                <p>- {t('ra:change')}</p>
            </span>
        </div>
    );
};

export default LegendIcons;
